$(document).ready(function() {

  /* Frontend */
  navigationOnScroll();
  anchorGoToHash();
  productModalTrigger();
  formStyles();
  socialShare();
  copyToClipboard();

  if($('.hero_home').length > 0){
    var rellax = new Rellax('.img_parallax', {
      breakpoints:[480, 768, 1080]
    });
  }

});
